import { MultiSelectItem } from "../multi-select/multi-select";
import { TableController } from "./table";

// Note: this class won't be used directly by external consumers.
/** ###Do Not Display### */
export class TableFilterSelectBinding {
  /** Filterable column that should be rendered in the table filter group. */
  public filterableColumn = "<";
}
export const refreshFiltersEventName = "refreshFilters";
export interface FilterableColumn {
  columnLabel: string;
  columnBinding: string;
  filteredToValues: any[];
  filterer: Filterer;
  getDataSource: () => any[];
}

export interface Filterer {
  /** Gets the list of filter options for a given column and data source. Return type is a hash table (keys can be arbitrary strings but should enforce uniqueness of the MultiSelectItems ). */
  getFilterOptions(column: FilterableColumn, data: any[]): { [key: string]: MultiSelectItem };
  /** Determines if a match currently exists for the given filterable column and dataItem. */
  matchExists(column: FilterableColumn, dataItem: any): boolean;
}

class PrimitiveFilterer implements Filterer {
  private static safeIndexer(obj: any, i: string) {
    return obj ? obj[i] : undefined;
  }
  public static evaluatePropertyPathSyntax(object: any, propertyPath: string): any {
    return propertyPath.split(".").reduce(PrimitiveFilterer.safeIndexer, object);
  }

  public getFilterOptions(column: FilterableColumn, data: any[]): { [key: string]: MultiSelectItem } {
    let hasPropertyPathSyntax = column.columnBinding.indexOf(".") >= 0;
    let newHash: { [key: string]: MultiSelectItem } = {};
    column.getDataSource().forEach((item) => {
      let value = hasPropertyPathSyntax
        ? PrimitiveFilterer.evaluatePropertyPathSyntax(item, column.columnBinding)
        : item[column.columnBinding];
      if (!(value in newHash)) {
        let menuItem: MultiSelectItem = { displayName: value, value: value, isSelected: undefined };
        newHash[value] = menuItem;
      }
    });
    return newHash;
  }

  public matchExists(column: FilterableColumn, dataItem: any): boolean {
    let hasPropertyPathSyntax = column.columnBinding.indexOf(".") >= 0;
    return (
      column.filteredToValues.indexOf(
        hasPropertyPathSyntax
          ? PrimitiveFilterer.evaluatePropertyPathSyntax(dataItem, column.columnBinding)
          : dataItem[column.columnBinding]
      ) >= 0
    );
  }
}

export let primitiveFilterer: Filterer = new PrimitiveFilterer();

export class TableFilterSelectController {
  public filterableColumn: FilterableColumn;
  public currentFilterData: MultiSelectItem[] = [];
  public itemHash: { [key: string]: MultiSelectItem } = {};
  public filterChanged: (arg: { column: FilterableColumn; filterValues: string[] }) => void;
  public tableController: TableController;
  // @ngInject
  constructor(private $scope: ng.IScope) {
    $scope.$on(refreshFiltersEventName, () => {
      this.refreshMenuItems();
    });
  }

  public menuItemSelected() {
    let filteredValues = this.getCurrentFilteredValues();
    this.filterableColumn.filteredToValues = filteredValues;

    if (this.filterChanged) {
      this.filterChanged({ column: this.filterableColumn, filterValues: filteredValues });
    }

    if (this.tableController.functionalities.pagination.isEnabled) {
      this.tableController.functionalities.pagination.setFilterValues(
        this.filterableColumn.columnBinding,
        filteredValues
      );
    }
    this.tableController.gridOptions.api.onFilterChanged();
  }

  public getMenuItems(): MultiSelectItem[] {
    return this.currentFilterData;
  }

  public onFilterOpenedChanged(wasOpened: boolean) {
    if (wasOpened) {
      this.refreshMenuItems();
    }
  }

  private refreshMenuItems() {
    let oldHash = this.itemHash;
    this.currentFilterData = [];
    let newHash = this.filterableColumn.filterer.getFilterOptions(
      this.filterableColumn,
      this.filterableColumn.getDataSource()
    );
    Object.keys(newHash).forEach((item) => {
      let newItem = newHash[item];
      let oldItem = oldHash[item];
      newItem.isSelected = newItem.isSelected || (oldItem && oldItem.isSelected);
      this.currentFilterData.push(newItem);
    });
    this.itemHash = newHash;
  }

  private getCurrentFilteredValues(): string[] {
    let filteredValues: string[] = [];
    this.currentFilterData.forEach((item) => {
      if (item.isSelected) {
        filteredValues.push(item.value);
      }
    });

    return filteredValues;
  }
}
export const sdTableFilterSelect: ng.IComponentOptions = {
  bindings: <any>new TableFilterSelectBinding(),
  controller: TableFilterSelectController,
  require: {
    tableController: "^^sdTable"
  },
  templateUrl: "../ShellCommon/Controls/table/table-filter-select.html"
};
